import axios from 'axios';
import { STORAGE_KEYS } from '../constants';

const API_URL = import.meta.env.VITE_API_URL || 'https://ads.octagon-lab.com';

/**
 * The API has no dedicated login endpoint, so credentials are verified by
 * issuing a cheap /stat request. The project is arbitrary — only the response
 * status matters.
 */
const AUTH_PROBE_PARAMS = { time_interval: 'day', project: 'cleanify' };

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setupInterceptors = (store, logoutAction) => {
  api.interceptors.request.use(
    (config) => {
      if (!config.headers.Authorization) {
        const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
        if (token) {
          config.headers.Authorization = `basic ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        store.dispatch(logoutAction());
      }
      return Promise.reject(error);
    },
  );
};

export const checkAuth = async (login, password) => {
  const response = await api.get('/stat', {
    headers: { Authorization: `basic ${btoa(`${login}:${password}`)}` },
    params: AUTH_PROBE_PARAMS,
  });
  return response.data;
};
